import { AfterViewInit, Component, ElementRef, forwardRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import Debug from 'debug';
import { AumFormField } from './../aumFormField/aum-form-field';

const debug = Debug('aumico:aumico-lib-core-fe:AumTextarea');

/**
 * to overwrite the with you have to change the css of .mat-form-field-infix
 */
@Component({
    selector: 'aum-textarea',
    styleUrls: [
        './../aumFormField/aum-form-field.scss',
        './../aumFormField/aum-form-field-outline.scss',
        './../aumFormField/aum-input.scss',
    ],
    templateUrl: './aum-textarea.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AumTextarea),
            multi: true,
        },
    ],
    host: {
        class: 'aum-textarea aum-form-field',
    },
    inputs: ['size'],
})
export class AumTextarea extends AumFormField implements AfterViewInit {
    @ViewChild('input', { static: true }) el: ElementRef;

    ngAfterViewInit() {
        const randomString = Math.random().toString(36).slice(-6);
        this.renderer.setAttribute(this.el.nativeElement, 'name', randomString);
        this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', randomString);
    }
}
